<template>

  <div class="v">
    
    <Loading v-if="showLoading && loading" @close="onHide" />

    <transition
        name="custom-classes-transition"
        enter-active-class="animated fadeIn"
      >

      <Home v-if="!showLoading || !loading" @bindStart="openPage" />

    </transition>

  </div>

</template>

<script>
import Loading from "@/components/Loading";
import Home from "@/components/Home";
export default {
  props: ['showLoading'],
  data() {
    return {
      loading: true,
      show: false,
      isOff: true
    };
  },
  components: {
    Loading,
    Home
  },
  mounted() {},
  methods: {
    onHide() {
      // this.onHide();
      this.loading = false;
      // this.showLoading = false;
    },
    onClose() {
      // this.showLoading = false;
      // this.loading = false;
      // this.show    = true;
    },
    openPage(page) {
      this.$emit("bindStart", page);
      // console.log(page);
      // this.show = page;
    },
  },
};
</script>